import React, { useState } from 'react';
import styled from 'styled-components';
import PlaceHolder from './PlaceHolder';
import HeaderTag from './HeaderTag';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const HalfGradient = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(#00000000, #00000040);
  z-index: 1;
`;

const TextWrapper = styled.div`
  display: flex;
  position: absolute;
  left: -1px;
  bottom: -1px;
  z-index: 100;
  flex: 1;
`;

const Imagez = (props) => {
  const {
    image,
    hasGradient,
    br,
    dropShadow,
    height,
    style,
    text,
    handleNoImage,
    fit,
    imageStyles,
    full,
    loaderWidth,
  } = props;

  // const imageIsCached = ImagezCached(image);
  const [isLoading, setIsLoading] = useState(true);
  const [errorImage, setErrorImage] = useState(false);

  const loadingDone = () => {
    setIsLoading(false);
  };

  const onError = (e) => {
    setErrorImage(true);
    handleNoImage && handleNoImage();
  };

  const shadow = dropShadow ? { filter: 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5))' } : {};

  const rightLimit = full ? { right: '-1px' } : {};

  return (
    <Wrapper style={{ ...style, height, background: '#F0F0F0', border: errorImage ? '1px solid #C4C4C4' : 'none', borderRadius: br }}>
      {image && !errorImage ? (
        <PlaceHolder isLoading={isLoading} br={br} style={{ height }} width={loaderWidth} />
      ) : null}
      {!isLoading && errorImage && (
        <TextWrapper style={{ ...rightLimit, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <HeaderTag
            name={text}
            color="#C4C4C4"
            size="1rem"
            style={{
              color: '#C4C4C4',
              wordBreak: 'break-word',
              userSelect: 'none',
              padding: '0px',
              margin: '0px',
              width: '100%',
              textAlign: 'center',
              ...shadow,
            }}
          />
        </TextWrapper>
      )}
      {image && !errorImage ? (
        <Image
          src={image}
          onError={onError}
          style={{
            borderRadius: br,
            height,
            objectFit: fit ? fit : 'cover',
            ...imageStyles,
          }}
          onLoad={loadingDone}
        />
      ) : null}

      {hasGradient && !errorImage ? <HalfGradient style={{ borderRadius: br }} /> : null}
    </Wrapper>
  );
};

export default Imagez;
